import { useMemo } from 'react';
import { Alert } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { AppTable } from 'shared/UI/UIKit/Table';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppEmpty } from 'shared/UI/UIKit/Empty';
import { CurriculumScheduleStatus } from 'services/api';
import { alertMessages, alertTypes, useEducationPlanSchedules } from '../model';
import styles from './styles.module.scss';

export const EducationPlanSchedules = () => {
  const {
    state: { configuration, dataSource, columns, loading, scheduleStatus },
    methods: { onRowHandleClick, handleGenerateSchedule, handleUpdateSchedule },
  } = useEducationPlanSchedules();

  const generationMessage = useMemo(() => {
    const message = scheduleStatus
      ? alertMessages[scheduleStatus as keyof typeof alertMessages]
      : null;

    if (!message || !scheduleStatus) return null;

    return (
      <Alert
        message={message}
        type={alertTypes[scheduleStatus as keyof typeof alertTypes]}
        action={
          scheduleStatus === CurriculumScheduleStatus.Processing ? (
            <AppButton onClick={handleUpdateSchedule} icon={<ReloadOutlined />}>
              Обновить
            </AppButton>
          ) : null
        }
      />
    );
  }, [scheduleStatus]);

  return (
    <>
      <AppFlex direction="row" justifyContent="flex-end" className={styles.controls}>
        <AppButton
          onClick={handleGenerateSchedule}
          disabled={
            scheduleStatus === CurriculumScheduleStatus.Processing ||
            loading ||
            configuration?.status === 'DRAFT'
          }
        >
          Сгенерировать
        </AppButton>
      </AppFlex>
      {generationMessage}
      <AppTable
        dataSource={dataSource}
        columns={columns}
        loading={loading}
        rowKey={(record) => record.id}
        onRow={onRowHandleClick}
        locale={{
          emptyText: (
            <AppFlex>
              <AppEmpty description="Расписание не найдено. Пожалуйста, сгенерируйте расписание" />
            </AppFlex>
          ),
        }}
      />
    </>
  );
};
